import { render, staticRenderFns } from "./LpuListPartners.vue?vue&type=template&id=0093a99e&scoped=true&"
import script from "./LpuListPartners.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuListPartners.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuListPartners.vue?vue&type=style&index=0&id=0093a99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0093a99e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0093a99e')) {
      api.createRecord('0093a99e', component.options)
    } else {
      api.reload('0093a99e', component.options)
    }
    module.hot.accept("./LpuListPartners.vue?vue&type=template&id=0093a99e&scoped=true&", function () {
      api.rerender('0093a99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/LpuListPartners.vue"
export default component.exports